/* Avaliações da ANINA: filtros, "ver mais", foto ampliada e o formulário,
   que envia para o app próprio pelo proxy da loja (/apps/avaliacoes/enviar). */
class AninaAvaliacoes extends HTMLElement {
  connectedCallback() {
    if (this.dataset.pronto) return;
    this.dataset.pronto = '1';
    this.porPagina = parseInt(this.dataset.porPagina || '6', 10);
    this.mostrando = this.porPagina;
    this.filtro = 'todas';
    this.itens = [...this.querySelectorAll('.anina-av__item')];
    this.dlgForm = this.querySelector('[data-dialogo-form]');
    this.dlgFoto = this.querySelector('[data-dialogo-foto]');
    this.form = this.querySelector('[data-form]');

    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);
    this.form?.addEventListener('submit', (e) => this.enviar(e));
    this.form?.addEventListener('change', (e) => {
      if (e.target.name === 'nota') this.pintarNota(parseInt(e.target.value, 10));
    });
    this.querySelectorAll('.anina-av__notas-op label').forEach((l, i) => {
      l.addEventListener('mouseenter', () => this.pintarNota(i + 1));
      l.addEventListener('mouseleave', () => this.pintarNota(this.notaAtual()));
    });
    [this.dlgForm, this.dlgFoto].forEach((d) =>
      d?.addEventListener('click', (e) => {
        if (e.target === d) d.close();
      })
    );
    this.aplicar();
    if (location.hash === '#avaliar') this.abrirForm();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(e) {
    const t = e.target.closest('button, a');
    if (!t || !this.contains(t)) return;
    if (t.matches('[data-abrir-form]')) this.abrirForm();
    else if (t.matches('[data-fechar]')) t.closest('dialog')?.close();
    else if (t.matches('[data-mais]')) {
      this.mostrando += this.porPagina;
      this.aplicar();
    } else if (t.matches('[data-filtro]')) {
      this.filtro = t.dataset.filtro;
      this.mostrando = this.porPagina;
      this.querySelectorAll('[data-filtro]').forEach((b) => b.setAttribute('aria-pressed', String(b === t)));
      this.aplicar();
    } else if (t.matches('[data-foto]')) {
      const img = this.dlgFoto.querySelector('[data-foto-grande]');
      img.src = t.dataset.foto;
      img.alt = t.querySelector('img')?.alt || '';
      this.dlgFoto.querySelector('[data-foto-legenda]').textContent = t.dataset.legenda || '';
      this.dlgFoto.showModal();
    }
  }

  aplicar() {
    let visiveis = 0;
    let passam = 0;
    this.itens.forEach((li) => {
      const ok =
        this.filtro === 'todas' ||
        (this.filtro === 'fotos' && li.dataset.fotos === '1') ||
        li.dataset.origem === this.filtro;
      if (ok) passam += 1;
      const mostra = ok && visiveis < this.mostrando;
      if (mostra) visiveis += 1;
      li.hidden = !mostra;
    });
    const mais = this.querySelector('[data-mais]');
    if (mais) mais.hidden = passam <= this.mostrando;
  }

  abrirForm() {
    if (!this.dlgForm) return;
    this.form.hidden = false;
    this.dlgForm.querySelector('[data-ok]').hidden = true;
    this.dlgForm.showModal();
  }

  notaAtual() {
    const r = this.form?.querySelector('input[name="nota"]:checked');
    return r ? parseInt(r.value, 10) : 0;
  }

  pintarNota(n) {
    this.querySelectorAll('.anina-av__notas-op label').forEach((l, i) => l.classList.toggle('is-on', i < n));
  }

  msg(texto) {
    this.form.querySelector('[data-msg]').textContent = texto;
  }

  async enviar(e) {
    e.preventDefault();
    const f = this.form;
    const dados = new FormData(f);
    if (!this.notaAtual()) return this.msg('Escolha uma nota de 1 a 5 estrelas.');
    if (!String(dados.get('nome') || '').trim()) return this.msg('Preencha o nome que vai aparecer.');
    const email = String(dados.get('email') || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return this.msg('Confira o e-mail da compra.');
    if (String(dados.get('texto') || '').trim().length < 10) return this.msg('Conte um pouco mais sobre o perfume (pelo menos 10 letras).');
    if (!dados.get('aceite')) return this.msg('Marque a autorização para publicarmos sua avaliação.');

    const fotos = [...(f.querySelector('[data-fotos-input]')?.files || [])];
    if (fotos.length > 3) return this.msg('Envie no máximo 3 fotos.');
    if (fotos.some((x) => x.size > 8 * 1024 * 1024)) return this.msg('Cada foto pode ter até 8 MB.');
    dados.delete('fotos');
    fotos.forEach((x) => dados.append('fotos', x, x.name));

    const btn = f.querySelector('[data-enviar]');
    btn.disabled = true;
    btn.textContent = 'Enviando...';
    this.msg('');
    try {
      const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const r = await fetch(`${base}apps/avaliacoes/enviar`, { method: 'POST', body: dados });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j.ok) throw new Error(j.erro || 'Não conseguimos enviar agora.');
      f.reset();
      this.pintarNota(0);
      f.hidden = true;
      this.dlgForm.querySelector('[data-ok]').hidden = false;
    } catch (err) {
      this.msg(`${err.message} Tente de novo em alguns minutos ou fale com a gente pelo WhatsApp.`);
    } finally {
      btn.disabled = false;
      btn.textContent = 'Enviar avaliação';
    }
  }
}

if (!customElements.get('anina-avaliacoes')) customElements.define('anina-avaliacoes', AninaAvaliacoes);
